import * as yup from 'yup';
import 'yup-phone';

const buyNftSchema = yup.object().shape({
  currentPassword: yup.string().required('Mandatory Current password field!')
});
export { buyNftSchema };
